import type { Lang } from '@aera/schema';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import adminEn from './admin.en.json';
import adminZh from './admin.zh.json';
import en from './ui.en.json';
import zh from './ui.zh.json';

const setDocumentLang = (lang: string) => {
  if (typeof document !== 'undefined') document.documentElement.lang = lang === 'zh' ? 'zh-CN' : 'en';
};

// <html lang> follows i18n from the first render (index.html says zh-CN), not only after the toggle:
// /privacy and /admin load no session, and English text under lang="zh-CN" is read with a Chinese voice.
i18n.on('languageChanged', setDocumentLang);

/** UI chrome only; question and option text comes from the questionnaire's zh/en fields. */
void i18n.use(initReactI18next).init({
  resources: {
    zh: { translation: zh, admin: adminZh },
    en: { translation: en, admin: adminEn },
  },
  lng: initialLang(),
  fallbackLng: 'zh',
  interpolation: { escapeValue: false },
  returnNull: false,
});
setDocumentLang(i18n.language ?? initialLang());

function initialLang(): Lang {
  if (typeof navigator === 'undefined') return 'zh';
  return navigator.language?.toLowerCase().startsWith('zh') ? 'zh' : (navigator.language ? 'en' : 'zh');
}

/** The language toggle sets the UI language and document.documentElement.lang together. */
export function applyLang(lang: Lang): void {
  if (i18n.language !== lang) void i18n.changeLanguage(lang);
  setDocumentLang(lang);
}

export default i18n;
